export default (state = [], action) => {
    switch (action.type) {
        case "SEARCH_CHARACTERISTICS_DATA":
            return action.payload;
        default:
            return state;
    }
};